export default "__VITE_ASSET__DogQxT8s__"